// extracted by mini-css-extract-plugin
module.exports = {"note":"_3gK1R_","alert":"_3A9_X5","shine-lines":"_1JboVJ"};